import { Box, Grid, Stack, Typography } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcContainer, MprcMessageBox } from "components";
import { AssCorrectionResult, AssessmentInstanceDto, AssessmentMode, AssessmentPlayerMode, AssessmentQuestionDto } from "generated/CoreApi_v1";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    viewData: AssessmentInstanceDto;
    question: AssessmentQuestionDto;
}

export const AssPlayerFeedback: React.FC<IProps> = (props) => {

    const { viewData, question } = props;

    if (question.revision == null) return null;
    const revision = question.revision!;

    const hasFeedbackAlternatives = revision.alternatives && revision.alternatives?.length > 0 && revision.alternatives.some(x => x.feedback != null);
    const feedbacks = hasFeedbackAlternatives
        ? revision.alternatives!.filter(x => x.correctionResult == AssCorrectionResult.Wrong && x.feedback != null).map(x => x.feedback)
        : revision.feedback && revision.isCorrect == false
            ? [revision.feedback]
            : [];

    // Não renderiza se não for revisão ou não tem feedback definido.
    if ((viewData.mode == AssessmentMode.Challenge && question.revision == null) ||
        (viewData.mode != AssessmentMode.Challenge && (viewData.playerMode != AssessmentPlayerMode.UserReview || viewData.eval?.showFeedback != true || feedbacks.length == 0))) {
        return null;
    }

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer margin="dense">
            {
                viewData.mode == AssessmentMode.Challenge && question.revision != null && feedbacks.length == 0
                    ?
                    <Stack direction="column" alignContent="center" alignItems="center" mt={2}>
                        <Box
                            component="img"
                            maxHeight="95px"
                            maxWidth="130px"
                            src={question.revision.isCorrect ? AppImages.AssessmentPlayerCorrect : AppImages.AssessmentWrong}
                        />
                    </Stack>
                    :
                    <Grid container alignItems="center">
                        <Grid>
                            <Box
                                component="img"
                                minHeight="90px"
                                maxHeight="96px"
                                src={AppImages.AssessmentEvaluationFeedback}
                            />
                        </Grid>
                        <Grid size="grow">
                            <MprcMessageBox
                                variant="notice"
                                fullWidth
                                message={
                                    <>
                                        {
                                            feedbacks.length == 1
                                                ?
                                                <Typography variant="body1">{feedbacks[0]}</Typography>
                                                :
                                                <ul style={{ marginTop: 0, paddingLeft: 16 }}>
                                                    {
                                                        feedbacks.map((x, index) => <li key={index}><Typography variant="body1">{x}</Typography></li>)
                                                    }
                                                </ul>
                                        }
                                    </>
                                }
                            />
                        </Grid>
                    </Grid>
            }
        </MprcContainer>
    );
};
